import React, { useEffect, useState } from "react";
import { FiPhoneCall } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";

const NavbarTop = () => {
  let Navigate = useNavigate();
  const [isLogin, setIsLogin] = useState(false); // Default to false
  
  // Fetch login status from localStorage when component mounts
  useEffect(() => {
    const loginStatus = localStorage.getItem("isLogin") === "Yes";
    setIsLogin(loginStatus);
  }, []);
  
  const handleLogout = () => {
    Navigate("/login");
    localStorage.removeItem("isLogin");
    localStorage.removeItem("Token");
    localStorage.removeItem("customer_id");
  };

  const handleMyAccountClick = () => {
    if (isLogin) {
      Navigate("/dashboard"); // Navigate to dashboard if logged in
    } else {
      Navigate("/login"); // Navigate to login page if not logged in
    }
  };

  return (
    <div>
      <div className="hidden lg:block bg-gray-100">
        <div className="max-w-screen-2xl mx-auto px-3 sm:px-10">
          <div className="text-gray-700 py-2 font-sans text-xs font-medium border-b flex justify-between items-center">
            <span className="flex items-center">
              <FiPhoneCall className="mr-2" />
              For enquiry, Contact at {" "}   
              <a
                href="tel:+9922997390"
                className="font-bold text-[#008000] ml-1"
              >
                +9922997390
              </a>
               <p className="mr-1 ml-1">/</p>  
               <a href="mailto:info@azamdeal.com">
                info@azamdeal.com 
                </a>
            </span>

            <div className="lg:text-right flex items-center cursor-pointer">
              <Link to="/kisanPortal">
                <div className="font-medium hover:text-[#008000]">
                  Kissan Portal
                </div>
              </Link>
              <span className="mx-2">|</span>
              <Link to="/about-us">
                <div className="font-medium hover:text-[#008000]">About Us</div>
              </Link>
              <span className="mx-2">|</span>
              <Link to="/contact-us">
                <p className="font-medium hover:text-[#008000]">Contact Us</p>
              </Link>
              <span className="mx-2">|</span>

              {/* Check if logged in before navigating */}
              <button
                onClick={handleMyAccountClick}
                className="font-medium hover:text-[#008000]"
              >
                My account
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NavbarTop;
